export const getAddressData = state => state.addressPicker.deliveryAddress;
